import { useEffect, useRef } from 'react';
import { Box, Stack, Typography } from 'ui';
import { ImageOutlined } from 'ui/icons';

import type { PreviewGalleryImage } from '../../types';
import { PreviewImage } from '../PreviewImage/PreviewImage';

interface PreviewGalleryProps {
  images: PreviewGalleryImage[];
  onClick?: (image: PreviewGalleryImage) => void;
  isPortrait: boolean;
}

export const PreviewGallery = ({ images = [], onClick, isPortrait }: PreviewGalleryProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollContainerRef.current && images.length > 0) {
      const scrollContainer = scrollContainerRef.current;
      const scrollPosition = isPortrait ? scrollContainer.scrollWidth : scrollContainer.scrollHeight;

      scrollContainer.scrollTo({
        [isPortrait ? 'left' : 'top']: scrollPosition,
        behavior: 'smooth',
      });
    }
  }, [images.length, isPortrait]);

  return (
    <Stack
      direction={isPortrait ? 'row' : 'column'}
      alignItems="center"
      sx={{ color: 'white', width: isPortrait ? '100%' : undefined }}
      spacing={1}
      height={isPortrait ? '100%' : undefined}
      width={isPortrait ? undefined : '100%'}
      paddingLeft={isPortrait ? 2 : 0}
      paddingRight={isPortrait ? 2 : 0}
      paddingTop={isPortrait ? 0 : 2}
      paddingBottom={isPortrait ? 0 : 2}
    >
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography>{images.length}</Typography>
        <ImageOutlined />
      </Box>
      <Box
        ref={scrollContainerRef}
        sx={{
          overflowX: isPortrait ? 'auto' : 'hidden',
          overflowY: isPortrait ? 'hidden' : 'auto',
          width: isPortrait ? '100%' : undefined,
        }}
        padding={1}
      >
        <Box display="flex" sx={{ minWidth: 'max-content' }} flexDirection={isPortrait ? 'row' : 'column'} gap={2}>
          {images.map((image, i) => (
            <Box
              onClick={() => onClick?.(image)}
              key={i}
              position="relative"
              sx={{ border: '1px solid white', borderRadius: 1, flexShrink: 0, height: 40, marginRight: 1, width: 40 }}
            >
              <PreviewImage image={image} isPortrait={isPortrait} />
            </Box>
          ))}
        </Box>
      </Box>
    </Stack>
  );
};
